import { useLocation } from 'react-router-dom';

/**
 * The nav group a route belongs to, e.g. "Masters" above "Investment
 * Strategies".
 *
 * Derived from the path rather than passed in per page, so every screen gets
 * the same treatment without forty separate edits — and a page that moves
 * between nav groups picks up the right label on its own. The groups mirror
 * `baseNavigationItems` in Header.tsx; add a route there and here together.
 */
const SECTIONS: Array<[RegExp, string]> = [
  [/^\/(orders|etf-orders|execution-board|order-allocations|block-trades|order-generation-failures|order-recommendation-list|trade-suggestions|pending-orders)\b/, 'Orders & Execution'],
  [/^\/(holdings|scheme-wise-holdings|custody-holdings|bank-statements|risk-calculation|fa-holdings-process|custody-process|contract-notes)\b/, 'Holdings'],
  [/^\/soa\b/, 'SOA'],
  [/^\/(client-cash|scheme-cash|margin-calculation|portfolio-transactions|distributor-contribution|cash-environment|sell|management-fees)\b/, 'Financial Management'],
  [/^\/(portfolio-performance|stockwise-performance|clientwise-performance|portfolio-pe|execution-analytics|volume-monitor|broker-comparison|broker-wise-brokerage|sector-holdings|contribution-analysis)\b/, 'Performance & Analytics'],
  [/^\/(operations-checklist|operations-history|checklist)\b/, 'Operations'],
  [/^\/(clients|client-master|client-approvals|companies|schemes|strategies|masters|roles|roles-management|users|settings|vendor-symbol-mapping)\b/, 'Masters'],
  [/^\/(portfolio-qa|qa)\b/, 'Portfolio QA'],
  [/^\/(kite-connect|market-data-staleness|notifications)\b/, 'Tools'],
];

export function sectionLabelFor(pathname: string): string | undefined {
  for (const [pattern, label] of SECTIONS) {
    if (pattern.test(pathname)) return label;
  }
  return undefined;
}

/** Hook form — safe anywhere inside the Router, which is every page. */
export default function useSectionLabel(): string | undefined {
  const { pathname } = useLocation();
  return sectionLabelFor(pathname);
}
